<template>
  <transition name="cookie-consent">
    <div v-if="!cookieConsentResolved" class="cookie-consent" role="dialog" aria-live="polite" aria-label="Уведомление об использовании cookies">
      <p class="cookie-consent__text">
        Мы используем cookies и localStorage для работы сайта. Подробнее — в
        <router-link to="/cookie-policy" class="cookie-consent__link">политике cookies</router-link>
        и
        <router-link to="/personal-data-policy" class="cookie-consent__link">политике обработки персональных данных</router-link>.
      </p>
      <div class="cookie-consent__actions">
        <v-btn size="small" color="primary" @click="accept()">Принять</v-btn>
        <v-btn size="small" variant="text" @click="reject()">Отказаться</v-btn>
      </div>
    </div>
  </transition>
</template>

<script>
import { initYandexMetrika } from '@/utils/metrika'

export default {
  name: 'CookieConsent',
  computed: {
    cookieConsentResolved() {
      return this.$store.state.cookieConsentStatus !== null
    },
  },
  mounted() {
    this.$commit('loadCookieConsent')
  },
  methods: {
    accept() {
      this.$commit('acceptCookieConsent')
      initYandexMetrika()
    },
    reject() {
      this.$commit('rejectCookieConsent')
    },
  },
}
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 3000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(26, 95, 74, 0.15);
}

@media (min-width: 768px) {
  .cookie-consent {
    left: 24px;
    right: auto;
    max-width: 560px;
    bottom: 24px;
  }
}

.cookie-consent__text {
  margin: 0;
  flex: 1 1 220px;
  font-size: 13px;
  line-height: 1.5;
  color: #424242;
  text-transform: none;
}

.cookie-consent__link {
  color: #1a5f4a;
  text-decoration: underline;
}

.cookie-consent__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cookie-consent-enter-active,
.cookie-consent-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-consent-enter-from,
.cookie-consent-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
